export * from './src/bookings-v2-price-info-pricing.meta.js';
